/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningList } from "../../funcs/llmFineTuningList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListFineTuningJobsRequest$inboundSchema,
};

export const tool$llmFineTuningList: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-list",
  description: `List fine-tuning jobs

List your organization's fine-tuning jobs.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
